var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWindow = function SvgWindow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 84,
    height: 83,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#CC8CE6",
    d: "M4.884 19.766h75.12v59.27h3.942V3.944h-3.942v11.854H4.883V3.943H.94v75.094h3.943z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#CC8CE6",
    d: "M80.004 79.036H4.884v3.969h75.12zM72.092 67.182H56.27v3.969h15.823zM72.092 59.271H56.27v3.969h15.823zM12.795 27.65v23.735h59.297V27.651zm55.328 19.767h-27.65v-3.943h-3.97v3.943H16.739V31.62h39.531v3.942h3.969V31.62h7.885z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#CC8CE6",
    d: "M56.27 35.563h-7.886v3.942h7.885zM48.384 39.505h-7.912v3.97h7.912zM44.415 67.182h-31.62v3.969h31.62zM44.415 59.271h-31.62v3.969h31.62zM28.618 7.886H24.65v3.968h3.97zM28.618 35.563h-7.911v7.91h7.911zM20.707 7.886h-3.969v3.968h3.969zM12.795 7.886H8.853v3.968h3.942zM80.004 0H4.884v3.943h75.12z"
  })));
};
export default SvgWindow;